module.exports = __webpack_public_path__ + "img/head_eight.bb17f044.png";